import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAxFeHyIsbHXq-DYWGmShHQ3QriZqG0Z8E",
    libraries: "places",
  },
});
